<template>
  <Selector
    ref="sel"
    :options="runAsync"
    :labelKey="type == 'draft' ? 'taskName' : 'keyTask'"
    valueKey="id"
    v-bind="$attrs"
    @change="onChange"
  >
    <template #header>
      <div flex="~ wrap" mb--8 text-14 :style="`width: ${unrefElement(sel)?.offsetWidth - 20}px`">
        <div v-for="opt in data" :class="['btn', keys.includes(opt.key) && 'is-active']" mr8 mb8 lh-22 @click="toggle(opt)">{{ opt.value }}</div>
      </div>
    </template>
  </Selector>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { unrefElement } from '@vueuse/core';
import { remove } from '@vue/shared';
import { ElMessage } from 'element-plus';
import Selector from './Selector.vue'
import { useRequest } from 'vue-request';
import axios from '@/plugins/axios';

const props = defineProps({
  lookStatus: Number,
  type: String
})

const router = useRouter()
const sel = ref()

const keys = ref([])

const { data } = useRequest(() => axios.get('/task/query/all/field').then(e => e.data))

const url = () => {
  if (props.type == 'pending') {
    return '/pending/task/page'
  }
  if (props.type == 'draft') {
    return '/start/task/draft/query'
  }
  else {
    return '/look/task/page'
  }
}

const { refresh, runAsync } = useRequest((keyword) => {
  return axios.post(url(), {
    fieldType: 1,
    keyword,
    pageNum: 1,
    pageSize: 50,
    keys: keys.value.length ? keys.value : undefined,
    lookStatus: props.lookStatus
  }).then(e => e.data.records)
}, { manual: true })

function toggle(opt) {
  if (keys.value.includes(opt.key)) {
    remove(keys.value, opt.key)
  } else {
    keys.value.push(opt.key)
  }
  // refresh()
  sel.value.refresh()
}

function onChange(id) {
  if (props.type == 'draft') {
    // ElMessage.success('TODO')
  } else {
    router.push(`/task/waitDeal/${id}`)
  }
}
</script>

<style scoped lang="scss">
.btn {
  @apply px-12 rd-full b-(1 solid #00000015) hover:bg-#00000010 cursor-pointer;

  &.is-active {
    @apply  c-#179aee b-#179aee;
  }
}
</style>